module.exports = __webpack_public_path__ + "img/Katerina.c749a274.jpeg";